<template lang="html">
  <div class="">
    <div
      class="grid-x grid-padding-x"
      :class="{'vertical-align-middle': demoIcon}">
      <div class="small-12 cell">
        <select
          :name="name"
          @change="onChange"
          ref="dropdown"
          v-model="selected">
          <option disabled value="">{{ defaultText }}</option>
          <option
            v-for="option in options"
            v-bind:value="option.value">
            {{ option.name }}
          </option>
        </select>
      </div>

    </div>
  </div>
</template>

<script>

  export default {
    props: {
      name: {
        type: String,
        required: true,
      },
      defaultText: {
        type: String,
        required: true,
      },
      demoIcon: {
        type: Boolean,
        required: false,
      },
      fontColor: {
        type: String,
        required: false,
        default: '#4a5b68',
      },
      fontSize: {
        type: String,
        required: false,
      },
      height: {
        type: String,
        required: false,
      },
      initialValue: {
        type: String,
        required: false,
      },
      isBold: {
        type: Boolean,
        required: false,
      },
      options: {
        type: Array,
        required: true,
      },
      selectedFontColor: {
        type: String,
        required: false,
        default: '#000',
      },
      width: {
        type: String,
        required: false,
      },
    },
    data() {
      return {
        selected: this.initialValue,
      };
    },
    methods: {
      onChange() {
        this.$emit('dropdownChanged', this.selected);
        this.$refs.dropdown.blur();
        if (this.selectedFontColor) {
          this.$refs.dropdown.style.color = this.selectedFontColor;
          this.$refs.dropdown.style.fontWeight = 'bold';
        }
      },
    },
    created() {

    },
    beforeMount() {

    },
    mounted() {
      /* get the $ref for the select element and then assign the custom styles */
      if (this.fontColor) {
        this.$refs.dropdown.style.color = this.fontColor;
      }
      if (this.fontSize) {
        this.$refs.dropdown.style.fontSize = this.fontSize;
      }
      if (this.isBold) {
        this.$refs.dropdown.style.fontWeight = 'bold';
      }
      if (this.height) {
        this.$refs.dropdown.style.height = this.height;
      }
      if (this.width) {
        this.$refs.dropdown.style.width = this.width;
      }
      if (this.initialValue) {
        this.selected = this.initialValue;
      } else {
        this.selected = "";
      }
    },
    updated() {

    },
    beforeDestroy() {

    },
    destroyed() {

    },
  };
</script>

<style lang="scss" scoped>

  $grid: 12px;
  $blur-text-color: #7d8b96;
  $secondary-color: #c4cace;

  .vertical-align-middle {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .rare-dropdown {
    border: 1px;
    border-color: $blur-text-color;
    border-radius: 2.333 * $grid !important;
    border-style: solid;
    height: 4.666 * $grid;
    text-transform: uppercase;
    width: 18 * $grid;
  }

  .dropdown-chevron {
    position: relative;
    right: -48px;
  }

  select {
    /* TO DO: find a way to hard code the SVG here instead of using background-image.
       Perhaps using Base64 encoded img src in the HTML above? */
    background-image: url('~@/assets/img/navigation/down.svg');
    background-size: contain;
    border-color: $secondary-color;
    border-radius: 2.333 * $grid !important;
    cursor: pointer;
    font-size: 16px;
    height: 4.666 * $grid;
    letter-spacing: 0.2px;
    line-height: 1.5;
    margin-bottom: 0;
    padding-left: 2 * $grid;
  }

</style>



// WEBPACK FOOTER //
// src/lib/rare-patternlab/src/components/input/RareConfigurableDropdown.vue